export const GOODIE_GIVEAWAY_MIN_BUDGET = 2500;
export const GOODIE_GIVEAWAY_MAX_BUDGET = 50000;